import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { ApiservicesService } from 'src/app/services/apiservices.service';

// Optional: strongly-typed event kinds to match your backend
type ActivityEventType =
  | 'CREATED'
  | 'STATUS_CHANGED'
  | 'COMMENT_ADDED'
  | 'ATTACHMENT_ADDED';

interface Actor {
  userId?: string;
  role?: string;
  name?: string;
  email?: string;
}

export interface ActivityLogItem {
  id: string;
  refundRequestId: string;
  type: ActivityEventType;
  description: string;
  actor?: Actor;
  metadata?: Record<string, any>;
  createdAt: string | number;
}

type Group = { label: string; day: string; items: ActivityLogItem[] };

@Component({
  selector: 'app-refund-request-activity-log',
  templateUrl: './refund-request-activity-log.component.html',
  styleUrls: ['./refund-request-activity-log.component.scss'], // optional
})
export class RefundRequestActivityLogComponent implements OnInit {
  // Inputs coming from dialog.open(... data: { key, value, override })
  constructor(
    private readonly dialogRef: MatDialogRef<RefundRequestActivityLogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      key?: any;
      value?: any;
      override?: any;
      activityItems?: ActivityLogItem[];
    }
  ) {}

  // loading = false;
  order: 'desc' | 'asc' = 'desc';
  refundId?: string;
  sortBy: 'createdAt' | 'type' | 'actor' | 'description' = 'createdAt';

  // Header info (best-effort extraction from provided data)
  headerInfo?: {
    refundNumber?: string;
    orderNumber?: string;
    createdOn?: string | Date;
    totalAmount?: number;
  };

  // Flat list & grouped view
  items: ActivityLogItem[] = [];
  groups: Group[] = [];

  private baseItems: ActivityLogItem[] = [];

  // ngOnInit(): void {
  //   this.extractHeader();
  //   // this.loadDemoOrFetch();
  //   this.fetchActivityLog();
  // }
  ngOnInit(): void {
    this.extractHeader();
    this.initFromData(); // build baseItems once and render
  }

  public formatRole(role: string): string {
    if (!role) {
      return '';
    }
    switch (role.toLowerCase()) {
      case 'is_admin':
        return 'Admin';
      case 'customer':
        return 'Customer';
      default:
        return role.charAt(0).toUpperCase() + role.slice(1);
    }
  }
  // --- UI helpers ------------------------------------------------------------

  icon(type: ActivityEventType): string {
    switch (type) {
      case 'CREATED':
        return 'playlist_add';
      case 'STATUS_CHANGED':
        return 'swap_horiz';
      case 'COMMENT_ADDED':
        return 'chat_bubble_outline';
      case 'ATTACHMENT_ADDED':
        return 'attach_file';
      default:
        return 'info';
    }
  }

  iconClass(type: ActivityEventType): string {
    switch (type) {
      case 'CREATED':
        return 'is-created';
      case 'STATUS_CHANGED':
        return 'is-status';
      case 'COMMENT_ADDED':
        return 'is-comment';
      case 'ATTACHMENT_ADDED':
        return 'is-attachment';
      default:
        return '';
    }
  }

  trackGroup = (_: number, g: Group) => g.day;
  trackItem = (_: number, it: ActivityLogItem) => it.id;

  toggleOrder(): void {
    this.order = this.order === 'asc' ? 'desc' : 'asc';
    // this.fetchActivityLog();
    this.sortAndGroup();
  }

  private extractHeader(): void {
    console.log('this.data?.value=====================>>>', this.data?.value);
    const v = this.data?.value || {};
    const k = this.data?.key || {};
    this.refundId =
      v.refundId || v._id || v.id || k.refundId || k._id || k.id || undefined;
    this.headerInfo = {
      refundNumber: v.refund_request_number || k.refund_request_number,
      orderNumber:
        v.order_number || v.orderNumber || k.order_number || k.orderNumber,
      createdOn:
        v.created_on ||
        v.createdOn ||
        v.createdAt ||
        k.created_on ||
        k.createdAt,
      totalAmount:
        v.total_amount ?? v.totalAmount ?? k.total_amount ?? k.totalAmount,
    };
  }

  // private fetchActivityLog(): void {
  //   if (!this.refundId) {
  //     console.warn('Cannot fetch activity log: refundId is missing.');
  //     return;
  //   }

  //   // this.loading = true;
  //   this.items = [];

  //   const payload = {
  //     condition: { limit: 100, skip: 0 },
  //     searchcondition: { refundRequestId: this.refundId },
  //     sort: { type: this.order, field: 'createdAt' },
  //     project: {},
  //     token: '',
  //   };

  //   this.apiservice
  //     .getHttpDataPost('/refund-activity/refund-activity-log-list', payload)
  //     .subscribe({
  //       next: (res: any) => {
  //         this.items = (res.results || []).map((item: ActivityLogItem) => {
  //           const newItem = { ...item };
  //           if (
  //             newItem.type === 'COMMENT_ADDED' &&
  //             newItem.actor?.role === 'is_admin'
  //           ) {
  //             newItem.description = newItem.description.replace(
  //               /Customer comment:/i,
  //               'Admin Comment:'
  //             );
  //           }
  //           newItem.createdAt = new Date(item.createdAt).toISOString();
  //           return newItem;
  //         });

  //         this.sortAndGroup();
  //         // this.loading = false;
  //       },
  //       error: (err: any) => {
  //         console.error('Failed to fetch activity log:', err);
  //         this.items = [];
  //         this.groups = [];
  //         // this.loading = false;
  //       },
  //     });
  // }
  private initFromData(): void {
    const raw: ActivityLogItem[] = this.data?.activityItems || [];

    this.baseItems = raw.map((item) => {
      const copy: ActivityLogItem = { ...item };
      if (copy.type === 'COMMENT_ADDED' && copy.actor?.role === 'is_admin') {
        copy.description = (copy.description || '').replace(
          /Customer comment:/i,
          'Admin Comment:'
        );
      }
      copy.createdAt = new Date(item.createdAt).toISOString();
      return copy;
    });

    this.sortAndGroup();
  }

  private sortAndGroup(): void {
    // sort by createdAt only (since your UI has a single toggle)
    const sorted = [...this.baseItems].sort((a, b) => {
      const da = new Date(a.createdAt as any).getTime();
      const db = new Date(b.createdAt as any).getTime();
      return this.order === 'asc' ? da - db : db - da;
    });

    this.items = sorted;

    // group by day for your timeline
    const map = new Map<string, ActivityLogItem[]>();
    for (const it of sorted) {
      const d = new Date(it.createdAt);
      const key = `${d.getFullYear()}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(it);
    }

    this.groups = Array.from(map.entries()).map(([day, items]) => ({
      day,
      label: this.labelForDay(day),
      items,
    }));
  }
  private labelForDay(yyyyMmDd: string): string {
    // Render "Today", "Yesterday", else formatted date
    const [y, m, d] = yyyyMmDd.split('-').map((n) => +n);
    const date = new Date(y, m - 1, d);
    const today = new Date();
    const yest = new Date();
    yest.setDate(today.getDate() - 1);

    const sameDay = (a: Date, b: Date) =>
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();

    if (sameDay(date, today)) return 'Today';
    if (sameDay(date, yest)) return 'Yesterday';
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }
}
